import { TRequiresTimeChange } from '@/types/session.types';

export const isStartDateNotSet = (requiresTimeChange: TRequiresTimeChange | null | undefined): boolean => {
  if (!requiresTimeChange) return false;

  return requiresTimeChange.start_date || requiresTimeChange.start_time;
};
